import React, { useState, Fragment } from "react"
import useStyles from "./styles"
import { useDispatch } from "react-redux"
import PropTypes from "prop-types"
import CircularProgress from "@material-ui/core/CircularProgress"
import Button from "@material-ui/core/Button"
import { updateGeneralDataProperties } from "../../../../../actions/billing"
import { openSnackBar } from "../../../../../actions/snack-bar"

const SaveButton = ({ noteVal, inputError, shootId }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const pathArray = window.location.pathname.split("/")
  const lastBit = pathArray[pathArray.length - 1]
  //two diffrent objects to send to the server
  const estimateObj = { estimate_note: noteVal }
  const invoiceObj = { invoice_note: noteVal }
  //will handle estimate and invoice on admin side

  const handleSubmitNote = () => {
    if (lastBit === "estimate") {
      setLoading(true)
      dispatch(updateGeneralDataProperties(estimateObj, shootId))
        .then(() => {
          dispatch(openSnackBar({ message: "Note saved" }))
          setLoading(false)
        })
        .catch(err => {
          console.log(err)
          setLoading(false)
          dispatch(openSnackBar({ message: "Error saving note" }))
        })
    } else if (lastBit === "invoice") {
      setLoading(true)
      dispatch(updateGeneralDataProperties(invoiceObj, shootId))
        .then(() => {
          dispatch(openSnackBar({ message: "Note saved" }))
          setLoading(false)
        })
        .catch(err => {
          console.log(err)
          setLoading(false)
          dispatch(openSnackBar({ message: "Error saving note" }))
        })
    }
  }
  return (
    <Fragment>
      <Button
        className={classes.saveButton}
        variant="outlined"
        disabled={inputError}
        onClick={handleSubmitNote}
      >
        {loading ? (
          <CircularProgress size={20} className={classes.progress} />
        ) : (
          "Save"
        )}
      </Button>
    </Fragment>
  )
}

SaveButton.propTypes = {
  noteVal: PropTypes.string,
  inputError: PropTypes.bool,
  shootId: PropTypes.number,
}

export default SaveButton
